(() => {
  const cursor = document.querySelector('.gc-cursor');
  if (cursor) window.addEventListener('pointermove', e => { cursor.style.left=e.clientX+'px'; cursor.style.top=e.clientY+'px'; }, {passive:true});

  const burger=document.querySelector('.gc-menu-toggle');
  const mobile=document.querySelector('.gc-mobile-menu');
  if(burger && mobile){
    const closeMenu=()=>{
      mobile.style.display='none';
      document.body.classList.remove('gc-menu-open');
      burger.setAttribute('aria-expanded','false');
    };
    const toggle=()=>{
      const open=mobile.style.display==='block';
      if(open){ closeMenu(); }
      else{
        mobile.style.display='block';
        document.body.classList.add('gc-menu-open');
        burger.setAttribute('aria-expanded','true');
      }
    };
    burger.setAttribute('aria-expanded','false');
    burger.addEventListener('click',toggle);
    mobile.querySelectorAll('a').forEach(a=>a.addEventListener('click',closeMenu));
    window.addEventListener('keydown',e=>{ if(e.key==='Escape') closeMenu(); });
  }

  const observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');observer.unobserve(e.target)}}),{threshold:.12});
  document.querySelectorAll('.gc-reveal').forEach(el=>observer.observe(el));

  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce) document.documentElement.style.scrollBehavior='auto';
  window.addEventListener('scroll',()=>{
    const h=document.documentElement.scrollHeight-window.innerHeight;
    document.documentElement.style.setProperty('--gc-progress', (h>0?(scrollY/h*100):0)+'%');
  },{passive:true});
})();
